function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "M21.0938 21.875H3.90625C3.475 21.875 3.125 21.525 3.125 21.0938V14.8438C3.125 14.4125 3.475 14.0625 3.90625 14.0625C4.3375 14.0625 4.6875 14.4125 4.6875 14.8438V20.3125H20.3125V14.8438C20.3125 14.4125 20.6625 14.0625 21.0938 14.0625C21.525 14.0625 21.875 14.4125 21.875 14.8438V21.0938C21.875 21.525 21.525 21.875 21.0938 21.875Z",
  fill: "currentColor"
}), /*#__PURE__*/React.createElement("path", {
  d: "M12.5 15.625C12.3281 15.625 12.1547 15.5688 12.0125 15.4547L8.10626 12.3297C7.77033 12.0594 7.71564 11.5688 7.98439 11.2313C8.2547 10.8969 8.74689 10.8406 9.08283 11.1094L12.5 13.8422L15.9188 11.1078C16.2594 10.8391 16.7485 10.8953 17.0172 11.2297C17.286 11.5672 17.2328 12.0578 16.8953 12.3281L12.9891 15.4531C12.8453 15.5688 12.6719 15.625 12.5 15.625Z",
  fill: "currentColor"
}), /*#__PURE__*/React.createElement("path", {
  d: "M12.5 15.625C12.0688 15.625 11.7188 15.275 11.7188 14.8438V10.1562C11.7188 6.27969 14.8734 3.125 18.75 3.125C19.1812 3.125 19.5312 3.475 19.5312 3.90625C19.5312 4.3375 19.1812 4.6875 18.75 4.6875C15.7344 4.6875 13.2812 7.14063 13.2812 10.1562V14.8438C13.2812 15.275 12.9312 15.625 12.5 15.625Z",
  fill: "currentColor"
}));

var SvgImport = function SvgImport(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgImport, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/import.74a2cf86.svg";
export { ForwardRef as ReactComponent };